// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.wallet.client

import org.multipaz.cbor.DataItem
import org.multipaz.wallet.client.DocumentPreconsentApprovedReader
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.trustmanagement.TrustMetadata
import org.multipaz.crypto.X509Cert
import org.multipaz.cbor.Tstr
import org.multipaz.documenttype.DocumentAttributeSensitivity
import org.multipaz.trustmanagement.toDataItem
import org.multipaz.trustmanagement.fromDataItem

fun DocumentPreconsentApprovedReader.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "2nqv_YbOxF-14vaLK4mVg9rUa-hgbxkOIem4Z4M3X9Y")
val DocumentPreconsentApprovedReader_cborSchemaId = ByteString(-38, 122, -81, -3, -122, -50, -60, 95, -75, -30, -10, -117, 43, -119, -107, -125, -38, -44, 107, -24, 96, 111, 25, 14, 33, -23, -72, 103, -125, 55, 95, -42)

fun DocumentPreconsentApprovedReader.Companion.fromCbor(data: ByteArray): DocumentPreconsentApprovedReader {
    return DocumentPreconsentApprovedReader.fromDataItem(Cbor.decode(data))
}

val DocumentPreconsentApprovedReader.Companion.cborSchemaId: ByteString
    get() = DocumentPreconsentApprovedReader_cborSchemaId

fun DocumentPreconsentApprovedReader.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("metadata", this.metadata.toDataItem())
    builder.put("certificate", this.certificate.toDataItem())
    val approvedSensitivity = this.approvedSensitivity
    if (approvedSensitivity != null) {
        builder.put("approvedSensitivity", Tstr(approvedSensitivity.name))
    }
    return builder.end().build()
}

fun DocumentPreconsentApprovedReader.Companion.fromDataItem(dataItem: DataItem): DocumentPreconsentApprovedReader {
    val metadata = TrustMetadata.fromDataItem(dataItem["metadata"])
    val certificate = X509Cert.fromDataItem(dataItem["certificate"])
    val approvedSensitivity0 = if (dataItem.hasKey("approvedSensitivity")) {
        dataItem["approvedSensitivity"].let { DocumentAttributeSensitivity.valueOf(it.asTstr) }
    } else {
        null
    }
    return DocumentPreconsentApprovedReader(
        metadata = metadata,
        certificate = certificate,
        approvedSensitivity = approvedSensitivity0,
    )
}
